import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BulletinItemComponent } from './bulletin-item.component';

/**
 * Pipes
 */
import { PipesCoreModule } from '@app/core/pipes/pipes.module';

/**
 * Vendors
 */
import { ChipModule } from 'primeng/chip';
import { NgxYoutubePlayerModule } from 'ngx-youtube-player';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [
    BulletinItemComponent
  ],
  exports: [
    BulletinItemComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    PipesCoreModule,
    ChipModule,
    NgxYoutubePlayerModule,
    RippleModule,
    TooltipModule
  ]
})

export class BulletinItemModule {
  constructor() {}
}
